import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            // Small delay so it doesn't flash on page load
            const timer = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem('cookie_consent', 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            className="fixed bottom-0 inset-x-0 z-[200] animate-slideUp"
            style={{ animation: 'slideUp 0.5s ease-out' }}
        >
            <style>{`
                @keyframes slideUp {
                    from { transform: translateY(100%); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `}</style>
            <div className="max-w-5xl mx-auto px-4 pb-4">
                <div className="bg-slate-900/95 backdrop-blur-xl text-white rounded-2xl shadow-2xl border border-slate-700/50 p-5 md:p-6">
                    <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                        {/* Icon */}
                        <div className="shrink-0 w-10 h-10 bg-amber-500/20 rounded-xl flex items-center justify-center">
                            <svg className="w-5 h-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>

                        {/* Text */}
                        <div className="flex-1 min-w-0" dir="rtl">
                            <p className="text-sm font-bold mb-1">
                                🍪 אתר זה משתמש בעוגיות (Cookies)
                            </p>
                            <p className="text-xs text-slate-400 leading-relaxed">
                                אנו משתמשים בעוגיות לשיפור חוויית הגלישה ולניתוח סטטיסטי בהתאם לחוק הגנת הפרטיות הישראלי (1981) ותקנות התקשורת (בזק ושידורים). באפשרותך לקבל או לדחות את השימוש בעוגיות.{' '}
                                <a href="https://www.gov.il/he/departments/general/privacy-protection" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
                                    מידע נוסף
                                </a>
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-2 shrink-0 w-full md:w-auto" dir="rtl">
                            <button
                                onClick={accept}
                                className="flex-1 md:flex-none bg-green-500 hover:bg-green-600 text-white font-bold text-xs uppercase tracking-wider px-5 py-2.5 rounded-xl transition-all shadow-lg shadow-green-500/20"
                            >
                                אישור
                            </button>
                            <button
                                onClick={decline}
                                className="flex-1 md:flex-none bg-slate-700 hover:bg-slate-600 text-slate-300 font-bold text-xs uppercase tracking-wider px-5 py-2.5 rounded-xl transition-all"
                            >
                                דחייה
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
